import { HTMLAttributes } from 'react';
import { atom } from 'jotai';

import { Spinner } from '@restworld/ui-ds-base';
import { cn } from '@restworld/utils-common';

import { RestaurantStaticType } from './server-side/fetch-restaurant-information';

// The RestaurantShowCase component (and its RestaurantMap child) were removed: the /locale
// route now renders showcase-v2 (ShowCaseV2Content). These symbols are kept because they are
// still consumed elsewhere: restaurantDetailsAtom by restaurant-self-information; LocaleWrapper
// by the employer-not-found page; DefaultLoadingUi by the /locale, job-applications and employer
// loading states.
export const restaurantDetailsAtom = atom<Partial<RestaurantStaticType>>({});
restaurantDetailsAtom.debugLabel = 'restaurantDetailsAtom';

export const LocaleWrapper = ({ className, ...props }: HTMLAttributes<HTMLElement>) => (
  <div
    className={cn(
      'flex box-border lg:flex-row lg:justify-center flex-col xl:gap-12 lg:gap-8 gap-0 max-w-full',
      className
    )}
    {...props}
  />
);

export const DefaultLoadingUi = () => (
  <div className="fixed top-0 left-0 flex flex-col items-center justify-center h-screen w-screen ">
    <Spinner size="lg" color="primary" />
  </div>
);
